module.exports = __webpack_public_path__ + "assets/img/W3-3-F.b1716d9b.png";